export const EXTRACT_IMAGE_ELEMENTS_FROM_HTML = /<img [^>]*src="[^"]*"[^>]*>/gm
export const EXTRACT_URL_FROM_IMAGE_ELEMENT = /.*src="([^"]*)".*/